export default __webpack_public_path__ + "static/media/ssl.aa7fa88c.png";